module.exports = __webpack_public_path__ + "static/media/1-3.c3693924.mp3";